import script from "./LessonsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LessonsPage.vue?vue&type=script&setup=true&lang=js"

import "./LessonsPage.vue?vue&type=style&index=0&id=6e590afa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e590afa"]])

export default __exports__